import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

import { timeout } from '../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'HeaderChunksAndFooterLazy',
        path: () => path.join(__dirname, './ShopDepartmentMenu'),
        resolve: () => require.resolveWeak('./ShopDepartmentMenu'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "HeaderChunksAndFooterLazy" */ './ShopDepartmentMenu'),
            ]).then((proms) => proms[0]),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
